import { render, staticRenderFns } from "./EventFriendReferral.vue?vue&type=template&id=726ff4b2&scoped=true&"
import script from "./EventFriendReferral.vue?vue&type=script&lang=js&"
export * from "./EventFriendReferral.vue?vue&type=script&lang=js&"
import style0 from "./EventFriendReferral.vue?vue&type=style&index=0&id=726ff4b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726ff4b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VIcon})
